import { MouseEvent } from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

const buttonStyles = {
	color: 'black.main',
	lineHeight: '18px',
	'& .MuiButton-startIcon': {
		m: {
			xs: '0',
			md: '0 8px 0 0',
		},
		'& > *:nth-of-type(1)': {
			fontSize: '22px',
		},
	},
	minWidth: 'max-content',
	p: {
		xs: '0',
		md: '12px',
	},
	ml: {
		xs: '15px',
		md: '20px',
	},
};

export default function UserAccountMenuButton({
	firstName,
	lastName,
	openAccountMenu,
}: Readonly<{
	firstName: string | undefined;
	lastName: string | undefined;
	openAccountMenu: (event: MouseEvent<HTMLElement>) => void;
}>) {
	const userName = `${firstName} ${lastName}`;

	return (
		<Button
			sx={buttonStyles}
			aria-haspopup="true"
			onClick={openAccountMenu}
			startIcon={
				<Avatar
					sx={{
						bgcolor: 'primary.main',
						color: 'white.main',
						width: '25px',
						height: '25px',
						pt: '1px',
					}}
				>
					<Typography variant="h7SemiBold">
						{firstName?.at(0) ?? ''}
						{lastName?.at(0) ?? ''}
					</Typography>
				</Avatar>
			}
			data-testid="user-account-menu-button"
		>
			<Typography sx={{ display: { xs: 'none', md: 'block', fontWeight: 500 } }}>{userName}</Typography>
		</Button>
	);
}
